import { connect } from 'react-redux';

import { downloadCognitoFormAnswersCSV } from '../../../../../state/modules/cognitoFormAnswers/actions';
import CognitoFormAnswersCSVButton from '../components/CognitoFormAnswersCSVButton';

const mapStateToProps = (state) => {
  return {
    isDownloading: state.cognitoFormAnswers.get('isCSVDownloading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    download: (order, filter, cb) => {
      dispatch(downloadCognitoFormAnswersCSV(order, filter, cb));
    },
  };
};

const CognitoFormAnswersCSVButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormAnswersCSVButton);

export default CognitoFormAnswersCSVButtonContainer;
